import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 30px 0px 0px;\n  height: 148px;\n  width: 100%;\n  background-color: ", ";\n  @media screen and (max-width: 375px) {\n    justify-content: space-around;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import styled from '../utils/styling/styled-components';
import { A4_RoundActionButton } from '../A4_ActionButton';
import { theme } from '../theme';
var Actions = styled.div(_templateObject(), theme.colors.white);

var A4_MobileActions = function A4_MobileActions(props) {
  return /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, /*#__PURE__*/React.createElement(Actions, {
    className: props.className
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(A4_RoundActionButton, {
      key: index,
      text: action.text,
      icon: action.icon,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText
    });
  })));
};

export { A4_MobileActions };